import { Button } from '@bambi/component-library/src/components/Button/Button';
import { CopyIcon } from '@radix-ui/react-icons';

import { useModal } from 'src/common/modals/useModal';

import { PricingWizardModal } from '../AddPricingSchemeButton';

export function ClonePricingSchemeButton({
  pricingSchemeId,
}: {
  pricingSchemeId: string;
}) {
  const { open, setOpen, openModal } = useModal();
  return (
    <>
      <Button
        dataTestId="pricing-management-clone-button"
        onClick={openModal}
        variant="icon"
      >
        <div
          className="flex flex-col items-center text-xs"
          style={{ fontSize: '0.625rem' }}
        >
          <CopyIcon className="h-5 w-5 cursor-pointer hover:text-mint" />
          Copy
        </div>
      </Button>

      <PricingWizardModal
        open={open}
        setOpen={setOpen}
        pricingSchemeId={pricingSchemeId}
        mode="clone"
      />
    </>
  );
}
